import moment from "moment";

import isWeekend from "../validation/isWeekend";
import isSunday from "../validation/isSunday";
import isExcluded from "../validation/isExcluded";

const filterDates = (date: Date, filterParams: any) => {
    const value = moment(date).format("YYYY-MM-DD");
    let isAvailable = true;

    [isAvailable] = isWeekend(filterParams, value);
    [isAvailable] = isAvailable ? isSunday(filterParams, value) : [isAvailable];
    [isAvailable] = isAvailable
        ? isExcluded(filterParams, value)
        : [isAvailable];
    return isAvailable;
};

export default filterDates;
